"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdvanceFilter = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _fieldType = require("../fieldType");

var _vueJsonView = require("vue-json-view");

var _locale = require("../locale");

var _jsonComponent = require("../common/jsonComponent");

var _dec, _class, _class2, _descriptor, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var setDataByObj = _vueJsonView.Utils.setDataByObj,
    getDataByName = _vueJsonView.Utils.getDataByName;
var AdvanceFilter = (_dec = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(AdvanceFilter, _Mixins);

  var _super = _createSuper(AdvanceFilter);

  function AdvanceFilter() {
    var _this;

    (0, _classCallCheck2.default)(this, AdvanceFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "initValue", _descriptor, (0, _assertThisInitialized2.default)(_this));
    _this.visible = false;
    _this.addVisible = false;
    _this.list = [];
    return _this;
  }

  (0, _createClass2.default)(AdvanceFilter, [{
    key: "type",
    get: function get() {
      return 'filter';
    }
  }, {
    key: "options",
    get: function get() {
      return _fieldType.FieldType.trans2ListByType(this.formItems);
    }
  }, {
    key: "configs",
    get: function get() {
      var options = this.options;
      var out = {};
      options.forEach(function (item) {
        out[item.name] = item;
      });
      return out;
    }
  }, {
    key: "selectedNames",
    get: function get() {
      var list = this.list;
      return list.map(function (item) {
        return item.name;
      });
    }
  }, {
    key: "formInitValue",
    get: function get() {
      var out = {};
      this.list.forEach(function (item) {
        out[item.name] = item;
      });
      return out;
    }
  }, {
    key: "created",
    value: function created() {
      var initValue = this.initValue,
          configs = this.configs;
      this.list = initValue.map(function (item) {
        return _objectSpread(_objectSpread({}, configs[item.name]), item);
      });
    }
  }, {
    key: "addFilter",
    value: function addFilter(item) {
      var _cm$, _cm$2;

      var type = item._type;

      if ((0, _typeof2.default)(type) === 'object') {
        type = type.type;
      }

      var cm = _fieldType.FieldType.getFilterMethod(type);

      this.list.push(_objectSpread(_objectSpread({}, this.configs[item.name]), {}, {
        name: item.name,
        method: (_cm$ = cm[0]) === null || _cm$ === void 0 ? void 0 : _cm$.value,
        type: type,
        beforeFilter: (_cm$2 = cm[0]) === null || _cm$2 === void 0 ? void 0 : _cm$2.beforeFilter
      }));
      this.addVisible = false;
    }
  }, {
    key: "deleteFilter",
    value: function deleteFilter(i) {
      this.list.splice(i, 1);
    }
  }, {
    key: "onMethodChange",
    value: function onMethodChange(i, method) {
      var form = this.$refs.form;
      this.$set(this.list, i, _objectSpread(_objectSpread({}, this.list[i]), {}, {
        method: method,
        value: undefined
      }));

      if (form && form.form && form.form.setValues) {
        form.form.setValues((0, _defineProperty2.default)({}, this.list[i].name + '.value', undefined));
      }
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.$emit('change', []);
      this.list = [];
      this.visible = false;
    }
  }, {
    key: "onFilter",
    value: function onFilter() {
      var _this2 = this;

      var form = this.$refs.form;
      var list = this.list;

      if (form && form.doSubmit && typeof form.doSubmit === 'function') {
        form.doSubmit( /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
            var newValue;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // values: { ...{ value: any, method: string } }
                    newValue = list.map(function (item, i) {
                      var valueObj = values[item.name] || {};

                      if (item.beforeFilter) {
                        valueObj.value = item.beforeFilter(valueObj.value);
                      }

                      return _objectSpread({
                        name: item.dataIndex,
                        type: item.type
                      }, valueObj);
                    }) || [];

                    _this2.$emit('change', newValue);

                    _this2.visible = false;

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "renderAddFilter",
    value: function renderAddFilter() {
      var _this3 = this;

      var h = this.$createElement;
      var options = this.options,
          selectedNames = this.selectedNames;
      return h("a-popover", {
        "attrs": {
          "trigger": "click",
          "placement": "bottom",
          "overlayClassName": "json-table-dropdown"
        },
        "model": {
          value: _this3.addVisible,
          callback: function callback($$v) {
            _this3.addVisible = $$v;
          }
        }
      }, [h("a-button", {
        "style": "margin-top: 12px;",
        "attrs": {
          "type": "dashed",
          "block": true
        }
      }, [h("a-icon", {
        "attrs": {
          "type": "plus"
        }
      }), (0, _locale.tl)('advanceFilter.addFilter')]), h("div", {
        "slot": "content",
        "class": "dropdown-content"
      }, [options.map(function (item) {
        var disabled = selectedNames.includes(item.name);
        return h("div", {
          "on": {
            "click": function click() {
              return !disabled && _this3.addFilter(item);
            }
          },
          "class": {
            'dropdown-content-disabled': disabled
          }
        }, [item.title]);
      })])]);
    }
  }, {
    key: "renderFilterItems",
    value: function renderFilterItems() {
      var _this4 = this;

      var h = this.$createElement;
      var list = this.list,
          deleteFilter = this.deleteFilter,
          onMethodChange = this.onMethodChange;
      return list.map(function (item, i) {
        var cm = _fieldType.FieldType.getFilterMethod(item.type).map(function (c) {
          return _objectSpread(_objectSpread({}, c), {}, {
            label: (0, _locale.tl)(c.label)
          });
        });

        var am = cm.find(function (c) {
          return c.value === item.method;
        });
        var inputs = am && am.inputs || [];
        var input;

        var renderInput = function renderInput(input, j) {
          if (typeof input === 'string') {
            input = getDataByName(item, input);
          }

          return h("mh-form-item", {
            "class": "advance-filter-item-control",
            "attrs": {
              "name": "".concat(item.name, ".value").concat(j !== undefined ? "[".concat(j, "]") : ''),
              "formLayout": false,
              "required": true
            }
          }, [_vueJsonView.VueJsonView.ele2VNode(_this4.$createElement, input, item)]);
        };

        if (Array.isArray(inputs)) {
          input = inputs.map(renderInput);
        } else {
          input = renderInput(inputs);
        }

        return h("div", {
          "class": "advance-filter-item",
          "key": item.dataIndex
        }, [h("div", {
          "class": "advance-filter-item-label"
        }, [h("label", [item.title]), h("mh-form-item", {
          "attrs": {
            "name": "".concat(item.name, ".method"),
            "formLayout": false
          },
          "class": "advance-filter-item-select"
        }, [h("a-select", {
          "attrs": {
            "size": "small",
            "dropdownMatchSelectWidth": false,
            "options": cm
          },
          "on": {
            "change": function change(v) {
              return onMethodChange(i, v);
            }
          }
        })]), h("a", {
          "class": "advance-filter-close",
          "on": {
            "click": function click() {
              return deleteFilter(i);
            }
          }
        }, [(0, _locale.tl)('advanceFilter.del')])]), h("div", {
          "class": "advance-filter-item-control-wrapper"
        }, [input])]);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var h = arguments[0];
      var initValue = this.initValue,
          renderAddFilter = this.renderAddFilter,
          renderFilterItems = this.renderFilterItems,
          clearAll = this.clearAll,
          onFilter = this.onFilter,
          formInitValue = this.formInitValue;
      return h("a-popover", {
        "attrs": {
          "trigger": "click",
          "title": (0, _locale.tl)('advanceFilter.title'),
          "placement": "bottom",
          "overlayStyle": {
            'width': '360px'
          }
        },
        "model": {
          value: _this5.visible,
          callback: function callback($$v) {
            _this5.visible = $$v;
          }
        }
      }, [h("span", {
        "class": "json-table-actions-text"
      }, [h("a-icon", {
        "attrs": {
          "type": "filter",
          "theme": "filled"
        },
        "class": "json-table-primary-icon"
      }), (0, _locale.tl)('advanceFilter.title'), " (", initValue.length, ")"]), h("div", {
        "slot": "content",
        "class": "json-table-advance-filter"
      }, [renderAddFilter(), h("mh-form", {
        "class": "advance-filter-item-block",
        "attrs": {
          "initData": formInitValue,
          "layout": "vertical"
        },
        "ref": "form"
      }, [renderFilterItems(), h("div", {
        "class": "clearfix",
        "style": "margin: 32px 16px 0;"
      }, [h("div", {
        "class": "footer"
      }, [h("a-button", {
        "style": "margin-right: 8px;",
        "on": {
          "click": function click() {
            return clearAll();
          }
        }
      }, [(0, _locale.tl)('advanceFilter.clear')]), h("a-button", {
        "attrs": {
          "type": "primary",
          "htmlType": "submit"
        },
        "on": {
          "click": function click() {
            return onFilter();
          }
        }
      }, [(0, _locale.tl)('advanceFilter.filter')])])])])])]);
    }
  }]);
  return AdvanceFilter;
}((0, _vuePropertyDecorator.Mixins)(_jsonComponent.JsonComponent)), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "initValue", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.AdvanceFilter = AdvanceFilter;